import {
  Box,
  Button,
  ChevronDownIcon,
  ChevronRightIcon,
  Flex,
  ProfilePhoto,
  Text,
} from "@minervaproject/fds";
import React, { useState } from "react";

import { FeatureBreakoutRoomButtons } from "./feature_breakout_room_buttons";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { visitBreakoutRoom } from "shared/reducers/classroom";
import { BreakoutRoomType } from "shared/types";
import { UserType } from "shared/types/user";
import { localSelectors } from "store";
import { computeInitials, longDisplayName, profilePhotoUrl } from "utils/user";

function BreakoutRoomUsers({
  breakoutRoom,
  allUsers,
  activeBreakoutSessionId,
}: {
  breakoutRoom: BreakoutRoomType;
  allUsers: UserType[];
  activeBreakoutSessionId?: string;
}) {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const [showExpanded, setShowExpanded] = useState(false);
  const controlId = `breakout-room-users-${breakoutRoom.id}`;
  const breakoutRoomUsers = allUsers.filter((user) =>
    breakoutRoom.assigned_user_ids.includes(user.id),
  );

  const handleVisitGroup = () => {
    dispatch(visitBreakoutRoom({ userId: currentUserId, breakoutRoomId: breakoutRoom.id }));
  };

  return (
    <Box>
      <button
        type="button"
        aria-controls={controlId}
        aria-expanded={showExpanded}
        className="button-reset cursor-pointer w-full"
        onClick={() => setShowExpanded(!showExpanded)}
      >
        <Flex className="items-center" p={2}>
          <Text color="white" mr={2}>
            Group {breakoutRoom.title}
          </Text>
          {showExpanded ? (
            <ChevronDownIcon color="var(--white)" />
          ) : (
            <ChevronRightIcon color="var(--white)" />
          )}
        </Flex>
      </button>
      <ul id={controlId} aria-hidden={!showExpanded}>
        {showExpanded &&
          breakoutRoomUsers.map((user) => (
            <li key={user.id} className="pl4">
              <Flex my={2}>
                <ProfilePhoto
                  className="mr2"
                  size="sm"
                  src={profilePhotoUrl(user)}
                  initials={computeInitials(user)}
                />
                <Text kind="body-s" color="white">
                  {longDisplayName(user)}
                </Text>
              </Flex>
            </li>
          ))}
      </ul>
      {showExpanded && activeBreakoutSessionId && (
        <div className="px4 py2">
          <Button
            className="mb1 flex-none truncate"
            kind="classroom-secondary"
            onClick={handleVisitGroup}
          >
            Visit Group {breakoutRoom.title}
          </Button>
        </div>
      )}
      {showExpanded && !activeBreakoutSessionId && (
        <div className="px4 py2">
          <FeatureBreakoutRoomButtons breakoutRoom={breakoutRoom} allUsers={allUsers} />
        </div>
      )}
    </Box>
  );
}

export { BreakoutRoomUsers };
